import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import type { FC } from 'react';
import { useDeleteFacebookPage } from '../api/deleteFacebookPage';
import { useEnqueueSnackbar } from 'hooks';
import { useNavigate } from 'react-router';
import { AxiosError } from 'axios';

interface DeleteFacebookPageProps {
  isOpen: boolean;
  close: () => void;
  id: number;
  name: string;
}

const DeleteFacebookPage: FC<DeleteFacebookPageProps> = (
  {
    isOpen,
    close,
    id,
    name,
  }) => {
  const { onShowErrorAlert, onShowAlert } = useEnqueueSnackbar();
  const navigate = useNavigate();

  const deleteFacebookPage = useDeleteFacebookPage({
    config: {
      onSuccess: () => {
        onShowAlert('Facebook page deleted successfully');
        close();
        navigate('/cabinet/facebook/facebook-pages');
      },
      onError: (error: unknown) => {
        if (error instanceof AxiosError) {
          onShowErrorAlert((error.response?.data?.message as string) ?? 'Failed to delete Facebook page');
          return;
        }
        onShowErrorAlert('Failed to delete Facebook page');
      },
    },
  });

  const handleDelete = () => {
    deleteFacebookPage.mutate({ id });
  };

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogTitle>Delete Facebook Page</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete Facebook page &ldquo;{name}&rdquo;?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={deleteFacebookPage.isPending}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFacebookPage;
